<template>
  <div class="root" v-smooth-appear="{elements: '.smooth-appear'}">
    <div class="wrapper">
      <h1 class="title smooth-appear">
        Vladimir Verstoff
      </h1>
      <h2 class="sub smooth-appear">
        Web Developer
      </h2>
      <div class="location smooth-appear">
        <icon name="location" />
        RUSSIA, SIBERIA, 54
      </div>
      <div class="experience smooth-appear">
        4 year's experience
      </div>
      <div class="skills">
        <skills-list class="skills__category" :items="skills[0]" />
        <skills-list class="skills__category" :items="skills[1]" />
      </div>
      <div class="projects">
        <project-list :items="projects" />
      </div>
      <div class="contact smooth-appear">
        <ui-button href="mailto:contact@verstoff.ru" class="contact__button" target="_blank">
          CONTACT
        </ui-button>
      </div>
      <div class="links smooth-appear">
        <a v-for="(url, network) in socials" :href="url" :key="network" class="social-link" target="_blank">
          <icon :name="network" class="social-link__icon" height="30" width="auto"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import '@/icons'
import SkillsList from './SkillsList'
import ProjectList from './ProjectList'
import UiButton from './UiButton'
import SmoothAppear from '@/directives/SmoothAppear'

export default {
  name: 'hello',
  data () {
    return {
      skills: [
        [
          'HTML5', 'Web Extensions',
          'CSS3', 'BEM', 'LESS/SASS',
          'JS (ES6+)', 'Vue.js', 'Vuex',
          'Socket.io', 'SW', 'Webpack'
        ],
        [
          'Node.js', 'Express.js', 'Strapi',
          'PHP7', 'Yii Framework 1/2',
          'MySQL', 'Redis',
          'Sphinx', 'Ceph', 'RabbitMQ',
          'Docker', 'Vagrant'
        ]
      ],
      projects: [
        {
          title: 'Atavi.com',
          subtitle: 'Bookmark management service',
          url: 'https://atavi.com/about?from=verstoff',
          thumbnail: require('../../static/img/projects/atavi.png')
        }, {
          title: 'Find on Apple Music',
          subtitle: 'Google Chrome extension',
          url: 'https://chrome.google.com/webstore/detail/find-on-apple-music/bicaojpdepgklhhaebcokkcakakbglpe',
          thumbnail: require('../../static/img/projects/apple-music.png')
        }
      ],
      socials: {
        linkedin: 'https://www.linkedin.com/in/vladimir-verstov-244335111/',
        github: 'https://github.com/verstoff/',
        producthunt: 'https://www.producthunt.com/@vladimir_verstov/made'
      }
    }
  },
  components: {
    SkillsList, ProjectList, UiButton
  },
  directives: {
    SmoothAppear
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  padding: 40px;
  box-sizing: border-box;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title, .sub {
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
}
.title {
  font-size: 30px;
  letter-spacing: 0.12em;
}
.sub {
  margin-top: 5px;
  font-size: 20px;
  letter-spacing: 0.28em;
}
.location {
  margin-top: 20px;
  letter-spacing: 0.2em;
  font-weight: bolder;
  font-size: 13px;
  color: #cbcbcb;
}
.experience {
  margin-top: 5px;
  color: #cbcbcb;
  text-transform: uppercase;
  font-weight: bolder;
  font-size: 12px;
  letter-spacing: 0.05em;
}

.skills {
  margin-top: 50px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  max-width: 44em;
}
.skills__category {
  flex-basis: 0;
  flex-grow: 1;
  margin: 20px;
}

.contact {
  margin-top: 60px;
}

.links {
  display: flex;
  margin-top: 20px;
}
.social-link {
  display: block;
  padding: 5px;
  color: #000;
  opacity: 0.1;
  transition: all 0.3s ease-out;
}
.social-link:hover {
  opacity: 1;
  transform: scale(1.2);
}
.social-link__icon {

}
</style>



// WEBPACK FOOTER //
// Hello.vue?3dfac025